<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_CollectFormation')"
      width="800px"
      class="make-invoice-adjust-balance-dialog"
      :close-on-click-modal="false"
      :show-close="true"
      @close="cancel"
    >
      <div>
        <div>
          <div class="form-row" style="flex-direction:row;max-width: 920px">
            <el-form
              label-width="100px"
              label-position="left"
              style="margin-right:20px"
            >
              <cargo-ag-grid
                ref="backList"
                :show-side-bar="false"
                :grid-options="options"
                :column-defs="column"
                :row-data="rowList"
                style="width: 100%;min-width: 180px;min-height: 300px"
                @gridReady="params=>{gridApi=params.api}"
              />
            </el-form>
          </div>
        </div>
        <div class="spacing" />
        <div class="triggers" align="right">
          <el-button no="confirm" type="primary" @click="cancel">
            {{ $t('common.btn.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'CollectInfoWindow',
  components: { CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    rowList: { type: Array, required: false }
  },
  data() {
    return {
      loading: false,
      gridApi: null,
      options: {
        context: {
          componentParent: this
        },
        columnApi: null
      },
      rows: [],
      column: [
        {
          headerName: this.$t('CargoMsg.Cargo_InvoiceNo'), colId: 'invoiceNo', field: 'invoiceNo', width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InvoiceTitle'), colId: 'title', field: 'title', width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SettlementCompany'), colId: 'customerId', field: 'customerId', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Currency'), colId: 'currency', field: 'currency', width: 50
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Amount'), colId: 'needReceive', field: 'needReceive', width: 50,
          cellRenderer: params => {
            return ColumnUtils.formatNumber(params.value, 2, true)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PaymentType'), colId: 'receivable', field: 'receivable', width: 50,
          cellRenderer: params => {
            return params.value ? this.$t('CargoMsg.Cargo_Receivable') : this.$t('CargoMsg.Cargo_Dues')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WriteOffAmount'), colId: 'actualReceive', field: 'actualReceive', width: 50,
          cellRenderer: params => {
            return ColumnUtils.formatNumber(params.value, 2, true)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WriteOffStatus'), colId: 'actualReceive', field: 'actualReceive', width: 50,
          cellRenderer: params => {
            return params.data.needReceive === params.data.actualReceive ? this.$t('CargoMsg.Cargo_CollectedInFull') : this.$t('CargoMsg.Cargo_NotCollectedInFull')
          }
        }
      ]
    }
  },
  computed: {
    innerVisible() {
      return this.visible
    }
  },
  async beforeMount() {

  },
  mounted() {

  },
  methods: {
    cancel() {
      this.$emit('visibleHandler')
    }
  }
}
</script>
<style scoped>

ul li {
  list-style: none;
  font-size: 13px;
  color: #909399;
}

.spacing {
  padding-top: 20px;
}
</style>

